const showMore = (elem,show_num) => {
	$(elem).each(function() {
		let contents = $(this).find('li');
		let show = show_num;
		let num = contents.length;

		$(this).find('li:nth-child(n + ' + (show + 1) + ')').addClass('is-hidden');

		if(num < show) {
			$(this).find('.js-showMore').hide();
		}

		$('.js-showMore button').on('click', function () {
			$(this).parents(elem).find('li.is-hidden').slice(0, num).removeClass('is-hidden');
			if ($(this).parents(elem).find('li.is-hidden').length == 0) {
				$(this).parents('.js-showMore').fadeOut();
			}
		});
	})
}

export {showMore}
